import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {statusTypes} from 'ag-common/tools/fileStatus'
import Text from '#components/a/Text'
import {usePermissions} from '#hooks/usePermissions'

function NachweisDetailAzubiInstructions({nachweisStatus}) {
  const permissions = usePermissions()
  if (permissions.nachweis?.edit && (nachweisStatus === statusTypes.draft || nachweisStatus === statusTypes.new)) {
    return (
      <div className="nachweisdetail__taetigkeiten__sidebar">
        <Text text={i18n.t('Nachweis_edit_info')} />
        <ul>
          <li>{i18n.t('Nachweis_edit_info_betriebliche_taetigkeiten')}</li>
          <li>{i18n.t('Nachweis_edit_info_seminare')}</li>
          <li>{i18n.t('Nachweis_edit_info_unterweisungn')}</li>
          <li>{i18n.t('Nachweis_edit_info_betrieblichen_unterricht')}</li>
          <li>{i18n.t('Nachweis_edit_info_themen_berufschuluntericht')}</li>
        </ul>
      </div>
    )
  }
  return null
}

NachweisDetailAzubiInstructions.propTypes = {
  nachweisStatus: PropTypes.string.isRequired,
}

export default NachweisDetailAzubiInstructions
